import { render, staticRenderFns } from "./dialogComponent.vue?vue&type=template&id=7b1b563c&scoped=true&"
import script from "./dialogComponent.vue?vue&type=script&lang=js&"
export * from "./dialogComponent.vue?vue&type=script&lang=js&"
import style0 from "./dialogComponent.vue?vue&type=style&index=0&id=7b1b563c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1b563c",
  null
  
)

export default component.exports